import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "../../../../../Hooks";
import { StringHelper } from "../../../../../Utils";
function InformationRow({ titulo, informacion, descripcion = false }) {
    const { theme } = useTheme();
    return (
        <div className="mt-0 mr-3 mb-0 ml-3">
            <div
                className="m-0 text-muted"
                style={{
                    width: "100%",
                    fontSize: "1.8vh",
                    fontFamiliy: `Roboto,Helvetica Neue,Arial,sans-serif`,
                    fontWeight: 400,
                }}
            >
                {titulo}
            </div>
            <div
                className="m-0 text-wrap"
                style={{
                    width: "100%",
                    fontSize: "1.8vh",
                    fontFamiliy: `Roboto,Helvetica Neue,Arial,sans-serif`,
                    fontWeight: 400,
                    overflowWrap: "break-word",
                }}
            >
                {informacion !== undefined ? (
                    descripcion && informacion.length ? (
                        informacion.map((el, i) => {
                            return (
                                <div key={el.IdSec || i}>
                                    {typeof el == "string"
                                        ? StringHelper.cutLetter(el, 400, "...")
                                        : el}
                                </div>
                            );
                        })
                    ) : (
                        <>{informacion}</>
                    )
                ) : (
                    <Skeleton baseColor={theme.skeletonColor} />
                )}
            </div>
        </div>
    );
}
export default InformationRow;